export default {
      id: "icon-arrow-down-usage",
      viewBox: "0 0 9 8",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-arrow-down",
      toString: function () {
        return this.url;
      }
    }